import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteSearchTemplate} from 'src/openapi/admin/apis/SearchTemplateApi';
import {useAppDispatch} from 'src/store/hooks';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    setDefaultTemplate: () => void,
    onSuccess: () => void,
    onFail: (error: string) => void,
};

export const useRemoveTemplate = ({setDefaultTemplate, onSuccess, onFail}: Props) => {
    const apiDispatch = useAppDispatch();
    const eventAction = useCallback(async (template: UserSearchTemplate) => {
        if (template.isActive) {
            await setDefaultTemplate();

            return apiDispatch(deleteSearchTemplate({templateId: template.templateId}));
        } else {
            return apiDispatch(deleteSearchTemplate({templateId: template.templateId}));
        }
    }, [apiDispatch, setDefaultTemplate]);

    return useCommonEventHook({eventAction, onSuccess, onFail});
};
